module.exports = __webpack_public_path__ + "static/media/money-withdrawal.05697927.svg";